<div class="login-container">
    <!-- Watermark silhouette -->
    <div class="watermark">
        <img src="assets/images/kossaya/watermark.png" alt="" />
    </div>
    <!-- Loading Overlay -->
    <div *ngIf="isCheckingAuth" class="loading-overlay">
        <div class="loading-card">
            <div class="spinner"></div>
            <p>Memeriksa autentikasi...</p>
        </div>
    </div>

    <!-- ============ LEFT SIDE ============ -->
    <div class="login-left">
        <!-- Yellow circle decoration -->
        <div class="yellow-circle"></div>

        <!-- Bear Mascot -->
        <div class="mascot-wrapper">
            <img
                src="assets/images/kossaya/mascot.png"
                alt="Kos Saya Mascot"
                class="mascot-img"
            />
        </div>

        <!-- Banner -->
        <div class="banner-wrapper">
            <img
                src="assets/images/kossaya/banner.png"
                alt="Kelola Kosan Lebih Mudah"
                class="banner-img"
            />
        </div>

        <!-- Dots indicator -->
        <div class="dots-indicator">
            <span class="dot active"></span>
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </div>
    </div>

    <!-- ============ RIGHT SIDE ============ -->
    <div class="login-right" *ngIf="!isCheckingAuth">
        <!-- Logo -->
        <div class="logo-wrapper">
            <img
                src="assets/images/kossaya/logo.png"
                alt="Kos Saya Logo"
                class="logo-img"
            />
        </div>

        <!-- Form Card -->
        <div class="form-card">
            <!-- Welcome Back (mobile only) -->
            <h1 class="welcome-title">Welcome Back</h1>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="error-msg">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                {{ errorMessage }}
            </div>

            <form (ngSubmit)="onSignIn()">
                <!-- Email / Username -->
                <div class="form-group" *ngIf="!hasUsernameParam">
                    <label for="identity">Email / Username</label>
                    <div class="input-wrapper">
                        <input
                            id="identity"
                            type="text"
                            [(ngModel)]="credentials.identity"
                            name="identity"
                            placeholder="Masukan email atau username"
                            [disabled]="isLoading"
                            required
                            autocomplete="username"
                            autofocus
                        />
                        <span class="input-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                            </svg>
                        </span>
                    </div>
                </div>

                <!-- Password / PIN -->
                <div class="form-group">
                    <label for="secret">Password / PIN</label>
                    <div class="input-wrapper">
                        <input
                            #passwordInput
                            id="secret"
                            [type]="showPassword ? 'text' : 'password'"
                            [(ngModel)]="credentials.secret"
                            name="secret"
                            placeholder="Masukan password atau PIN"
                            [disabled]="isLoading"
                            required
                        />
                        <span class="input-icon clickable" (click)="showPassword = !showPassword">
                            <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                            <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                <line x1="1" y1="1" x2="23" y2="23"></line>
                            </svg>
                        </span>
                    </div>
                </div>

                <!-- Submit Button -->
                <button type="submit" class="btn-masuk" [disabled]="isLoading || isFingerprintLoading">
                    <span *ngIf="!isLoading">Masuk</span>
                    <span *ngIf="isLoading" class="btn-loading">
                        <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="20" height="20">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Masuk...
                    </span>
                </button>
            </form>

            <!-- Fingerprint Button -->
            <div class="fingerprint-section" *ngIf="showFingerprintBtn && !hasUsernameParam">
                <div class="divider">
                    <span>atau</span>
                </div>
                <button
                    type="button"
                    class="btn-fingerprint"
                    (click)="onFingerprintLogin()"
                    [disabled]="isLoading || isFingerprintLoading"
                    id="btn-fingerprint-login"
                >
                    <span *ngIf="!isFingerprintLoading" class="fingerprint-btn-content">
                        <!-- Fingerprint SVG icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="fingerprint-icon">
                            <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"/>
                            <path d="M14 13.12c0 2.38 0 6.38-1 8.88"/>
                            <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02"/>
                            <path d="M2 12a10 10 0 0 1 18-6"/>
                            <path d="M2 17c1 .5 2.5 1 4 1"/>
                            <path d="M20 12c.5 4.5 0 6.5-2 8"/>
                            <path d="M7 13.09C7 15 7.16 17 7.88 19"/>
                            <path d="M10.34 4.06A10 10 0 0 1 22 12"/>
                            <path d="M4.41 9a10 10 0 0 0-.41 3"/>
                        </svg>
                        Masuk dengan Sidik Jari
                    </span>
                    <span *ngIf="isFingerprintLoading" class="btn-loading">
                        <svg class="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="20" height="20">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Memverifikasi...
                    </span>
                </button>
            </div>

            <!-- Forgot Password -->
            <p class="forgot-password">
                Lupa Password? <a href="#">Klik di sini</a>
            </p>
        </div>
    </div>

    <!-- ============ BIOMETRIC ENABLE PROMPT ============ -->
    <div class="biometric-prompt-overlay" *ngIf="showBiometricPrompt">
        <div class="biometric-prompt-card">
            <div class="biometric-prompt-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"/>
                    <path d="M14 13.12c0 2.38 0 6.38-1 8.88"/>
                    <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02"/>
                    <path d="M2 12a10 10 0 0 1 18-6"/>
                    <path d="M2 17c1 .5 2.5 1 4 1"/>
                    <path d="M20 12c.5 4.5 0 6.5-2 8"/>
                    <path d="M7 13.09C7 15 7.16 17 7.88 19"/>
                    <path d="M10.34 4.06A10 10 0 0 1 22 12"/>
                    <path d="M4.41 9a10 10 0 0 0-.41 3"/>
                </svg>
            </div>
            <h2>Aktifkan Login Sidik Jari?</h2>
            <p>Login lebih cepat dan aman tanpa perlu memasukkan password setiap kali.</p>
            <div class="biometric-prompt-actions">
                <button class="btn-enable-bio" (click)="onEnableBiometric()" id="btn-enable-biometric">
                    Aktifkan
                </button>
                <button class="btn-skip-bio" (click)="onSkipBiometric()" id="btn-skip-biometric">
                    Lewati
                </button>
            </div>
        </div>
    </div>
</div>